import { Link } from "react-router";
import { Button } from "@dg/ui";
import { useAuth } from "../contexts/auth.js";

export function ForbiddenPage() {
  const { auth } = useAuth();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
      <h1 className="text-6xl font-bold text-muted-foreground">403</h1>
      <p className="text-xl font-semibold">
        You don't have permission to view this.
      </p>
      <div className="flex gap-2">
        <Button asChild variant="outline">
          <Link to="/">Go to dashboard</Link>
        </Button>
        {auth.status === "unauthenticated" && (
          <Button asChild>
            <Link to="/">Sign in</Link>
          </Button>
        )}
      </div>
    </div>
  );
}
